import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { RouteNavigationMenuComponent } from '../route-navigation-menu.component';

@NgModule({
	declarations: [RouteNavigationMenuComponent],
	exports: [RouteNavigationMenuComponent],
	imports: [CommonModule, RouterModule],
	providers: [],
})
export class RouteNavigationMenuModule {}
